module.exports = __webpack_public_path__ + "img/not_available.6fb1f81c.svg";